import React from 'react';
import FormCheckbox from '../../../../../Components/Form/FormCheckbox';
import keysToLowerCase from '../../../../../Helpers/keysToLowerCase';

const ManualExtensionData = function ManualExtensionData({
  defaultData,
  setValue,
}) {
  const extensionData = keysToLowerCase(
    JSON.parse(defaultData?.extensionData || '{}')
  );
  return (
    <FormCheckbox
      name="hasDynamicProgress"
      defaultChecked={extensionData?.hasDynamicProgress}
      onChange={(value) => setValue('hasDynamicProgress', value)}
    />
  );
};

export default ManualExtensionData;
